import Accordion from '01_core/components/layout/Accordion';
import CButton from '01_core/components/materials/CButton';
import { withCallAPI } from '01_core/components/system/CallAPI';
import { withCodeUtil } from '01_core/components/system/CodeUtil';
import { withRouter } from '01_core/components/system/CustomRouter';
import { LABEL } from '01_core/constants/labelConsts';
import { STRING_CONSTS } from '01_core/constants/stringConsts';
import { NOTICE_LATEST, STATUS } from '01_core/constants/APIs';
import dateUtil from '01_core/logics/dateUtil';
import stringUtil from '01_core/logics/stringUtil';
import moment from 'moment';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
 
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
 
import { HOME_DATA_KEY, PERMISSION_KEY, TYPES, homeActions } from '../homeActions';
import { styles } from '../styles';

const stylesFromTheme = (theme) => (typeof styles === 'function' ? styles(theme) : styles);
const StyledAccordionButton = styled(CButton)(({ theme }) => stylesFromTheme(theme).accordionButton || {});
const StyledNoticeInfoArea = styled('div')(({ theme }) => stylesFromTheme(theme).noticeInfoArea || {});
const StyledNoticeInfoRegisterDt = styled(Typography)(({ theme }) => stylesFromTheme(theme).noticeInfoRegisterDt || {});

export class NoticeInfoField extends React.Component {
  constructor(props) {
    super(props);
    props.displayContents(false);
  }

  componentDidMount = (prevProps) => {
    const { callAPI, setHomeData, displayContents } = this.props;
    const defSearchStartDt = this.getDefaultSearchDt();
    const NoticeHistoryLatestSendData = {
      srhStartDt:  defSearchStartDt,
    };
    
    displayContents(false);
    callAPI(NOTICE_LATEST, NoticeHistoryLatestSendData).then((response) => {
      if (response.status === STATUS.SUCCESS) {
        setHomeData(HOME_DATA_KEY.NOTICE_LATEST_DATA, response.data);
        displayContents(true);
      }else{
        setHomeData(HOME_DATA_KEY.NOTICE_LATEST_DATA, null);
      }
    });
  }

  getDefaultSearchDt = () => {
    return moment()
      .subtract(this.props.systemSettings.common_home_display_past_days, 'days')
      .format(dateUtil.DATETIME_FORMAT);
  };

  onHistoryClick = () => {
    this.props.history.push('/notice_history');
  };
 
  onRegisterClick = () => {
    this.props.history.push('/notice_register');
  };
 
  render() {
    const { intl, permission, systemSettings, noticeLatestData } = this.props;
 
    let historyButton = (
      <StyledAccordionButton
        component="span"
        onClick={(e) => {
          e.stopPropagation();
          this.onHistoryClick();
        }}
      >
        {intl.formatMessage({ id: LABEL.CORE_HISTORY })}
      </StyledAccordionButton>
    );
 
    let registerButton = (
      <StyledAccordionButton
        component="span"
        onClick={(e) => {
          e.stopPropagation();
          this.onRegisterClick();
        }}
      >
        {intl.formatMessage({ id: LABEL.CORE_REGISTER })}
      </StyledAccordionButton>
    );
 
    let noticeDataLabel = (!noticeLatestData || !noticeLatestData.content) ? (
      <Grid size={{ xs:12, sm: 12, md:12 }}>
        <Typography>
          {intl.formatMessage({ id: LABEL.COMMON_NO_INFO }, { 0: systemSettings.common_home_display_past_days })}
        </Typography>
      </Grid>
    ) : (
      <Grid size={{ xs:12 }} align='left'>
        <Typography>
          {noticeLatestData.content.split('\n').map((line, index) => (
            <span key={index}>
              {line}
              <br />
            </span>
          ))}
        </Typography>
      </Grid>
    );
    
    return (
      <Accordion
        title={intl.formatMessage({ id: LABEL.NOTICE_NOTICE_TITLE })}
        buttons={[historyButton, permission[PERMISSION_KEY.NOTICE_REGISTER] ? registerButton : null]}
      >
        <StyledNoticeInfoArea>
          <React.Fragment>{noticeDataLabel}</React.Fragment>
        </StyledNoticeInfoArea>
        <div>
          <StyledNoticeInfoRegisterDt>
            {intl.formatMessage({ id: LABEL.CORE_REGISTERED_DATE })}
            {STRING_CONSTS.COLON_ZENKAKU}
            { !noticeLatestData || !noticeLatestData.content ? (
              '-'
            ) : (
              stringUtil.emptyToHyphen(noticeLatestData.regDt)
            )}
          </StyledNoticeInfoRegisterDt>
        </div>
      </Accordion>
    );
  }
 }
 
const mapStateToProps = (state) => {
  return {
    systemSettings: state.coreLoginInfo.systemSettings,
    permission: state.home.permission,
    noticeLatestData: state.home.homeData[HOME_DATA_KEY.NOTICE_LATEST_DATA]
      ? state.home.homeData[HOME_DATA_KEY.NOTICE_LATEST_DATA]
      : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setHomeData: (fid, data) => dispatch(homeActions[TYPES.SET_HOME_DATA](fid, data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(injectIntl(withCallAPI(withCodeUtil(NoticeInfoField)))));